import axios from 'axios'
export const api = {
    url : 'https://tanwir.uz:6443'
};
axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('myToken');